import { useMutation } from "@tanstack/react-query";
import type { CreateIntentReturnRequestDto, ReturnRequestCreateIntentResponseDto } from "../generated/schema";
import { getReturnWidgetFetchClient } from "./return-widget-client";
import { SESSION_TOKEN_KEY } from "./use-session-token";

export async function publicCreatePaymentIntent(
  payload: CreateIntentReturnRequestDto,
): Promise<ReturnRequestCreateIntentResponseDto> {
  const token = localStorage.getItem(SESSION_TOKEN_KEY) ?? "";
  const { data, response } = await getReturnWidgetFetchClient().POST(
    "/public/return-request/checkout/create-intent",
    {
      body: payload,
      params: { header: { authorization: `Bearer ${token}` } },
    },
  );
  if (!response.ok) throw new Error("Failed to create payment intent");
  if (!data) throw new Error("No data returned from create intent");
  return data;
}

export function usePublicCreatePaymentIntent() {
  return useMutation({ mutationFn: publicCreatePaymentIntent });
}
